/**
 * Catálogos oficiales de Hacienda (Anexos y estructuras v4.4).
 * Viven aquí, tipados, porque no cambian por compañía y los usan igual el API y la web.
 */
function entries(list) {
    return list;
}
export function labelOf(list, code) {
    return list.find((e) => e.code === code)?.name ?? code ?? '—';
}
/** Tipos de comprobante y su código de dos dígitos dentro de la clave. */
export const DOCUMENT_KINDS = entries([
    { code: 'FE', name: 'Factura electrónica' },
    { code: 'ND', name: 'Nota de débito' },
    { code: 'NC', name: 'Nota de crédito' },
    { code: 'TE', name: 'Tiquete electrónico' },
    { code: 'FEC', name: 'Factura electrónica de compra' },
    { code: 'FEE', name: 'Factura electrónica de exportación' },
]);
export const DOCUMENT_KIND_CODE = {
    FE: '01',
    ND: '02',
    NC: '03',
    TE: '04',
    FEC: '08',
    FEE: '09',
};
export const MESSAGE_KIND_CODE = { CCE: '05', CPCE: '06', RCE: '07' };
/** CodigoTarifaIVA. */
export const IVA_RATES = entries([
    { code: '01', name: 'Tarifa 0% (Art. 32 RLIVA)', rate: 0 },
    { code: '02', name: 'Tarifa reducida 1%', rate: 1 },
    { code: '03', name: 'Tarifa reducida 2%', rate: 2 },
    { code: '04', name: 'Tarifa reducida 4%', rate: 4 },
    { code: '05', name: 'Transitorio 0%', rate: 0 },
    { code: '06', name: 'Transitorio 4%', rate: 4 },
    { code: '07', name: 'Transitorio 8%', rate: 8 },
    { code: '08', name: 'Tarifa general 13%', rate: 13 },
    { code: '09', name: 'Tarifa reducida 0,5%', rate: 0.5 },
    { code: '10', name: 'Tarifa exenta', rate: 0 },
    { code: '11', name: 'Tarifa 0% sin derecho a crédito', rate: 0 },
]);
export function ivaRate(code) {
    return IVA_RATES.find((r) => r.code === code)?.rate ?? 0;
}
/** Tarifa sugerida → código de tarifa (para autocompletar desde CABYS). */
export function ivaCodeForRate(rate) {
    const map = {
        '0': '10',
        '0.5': '09',
        '1': '02',
        '2': '03',
        '4': '04',
        '8': '07',
        '13': '08',
    };
    return map[String(rate)] ?? '08';
}
/** CondicionVenta. */
export const SALE_CONDITIONS = entries([
    { code: '01', name: 'Contado' },
    { code: '02', name: 'Crédito' },
    { code: '03', name: 'Consignación' },
    { code: '04', name: 'Apartado' },
    { code: '05', name: 'Arrendamiento con opción de compra' },
    { code: '06', name: 'Arrendamiento en función financiera' },
    { code: '07', name: 'Cobro a favor de un tercero' },
    { code: '08', name: 'Servicios prestados al Estado a crédito' },
    { code: '10', name: 'Venta a crédito en IVA hasta 90 días' },
    { code: '12', name: 'Venta de mercancía no nacionalizada' },
    { code: '13', name: 'Venta de bienes usados no contribuyente' },
    { code: '14', name: 'Arrendamiento operativo' },
    { code: '15', name: 'Arrendamiento financiero' },
    { code: '99', name: 'Otros' },
]);
/**
 * Condiciones a crédito: llevan `PlazoCredito` (XSD v4.4: "obligatorio cuando la venta del producto o prestación del
 * servicio sea a crédito"; 08 es "Servicios prestados al Estado a crédito"). Los códigos 09 y 11 de versiones
 * anteriores ya no existen en la enumeración de `CondicionVenta` v4.4.
 */
export const CREDIT_SALE_CONDITIONS = ['02', '08', '10'];
/** TipoMedioPago. */
export const PAYMENT_METHODS = entries([
    { code: '01', name: 'Efectivo' },
    { code: '02', name: 'Tarjeta' },
    { code: '03', name: 'Cheque' },
    { code: '04', name: 'Transferencia / depósito' },
    { code: '05', name: 'Recaudado por terceros' },
    { code: '06', name: 'SINPE Móvil' },
    { code: '07', name: 'Plataforma digital' },
    { code: '99', name: 'Otros' },
]);
export const CURRENCIES = entries([
    { code: 'CRC', name: 'Colón costarricense', symbol: '₡' },
    { code: 'USD', name: 'Dólar estadounidense', symbol: '$' },
    { code: 'EUR', name: 'Euro', symbol: '€' },
]);
/** TipoDocIR (InformacionReferencia). */
export const REFERENCE_DOCUMENT_TYPES = entries([
    { code: '01', name: 'Factura electrónica' },
    { code: '02', name: 'Nota de débito electrónica' },
    { code: '03', name: 'Nota de crédito electrónica' },
    { code: '04', name: 'Tiquete electrónico' },
    { code: '05', name: 'Nota de despacho' },
    { code: '06', name: 'Contrato' },
    { code: '07', name: 'Procedimiento' },
    { code: '08', name: 'Comprobante emitido en contingencia' },
    { code: '09', name: 'Devolución de mercadería' },
    { code: '10', name: 'Comprobante rechazado por Hacienda' },
    { code: '11', name: 'Sustituye factura rechazada por el receptor' },
    { code: '12', name: 'Sustituye factura de exportación' },
    { code: '13', name: 'Facturación mes vencido' },
    { code: '14', name: 'Comprobante del Régimen Especial' },
    { code: '15', name: 'Sustituye factura electrónica de compra' },
    { code: '16', name: 'Comprobante de proveedor no domiciliado' },
    { code: '17', name: 'Nota de crédito a factura de compra' },
    { code: '18', name: 'Nota de débito a factura de compra' },
    { code: '99', name: 'Otros' },
]);
/** Codigo (InformacionReferencia). El 03 no existe en v4.4. */
export const REFERENCE_CODES = entries([
    { code: '01', name: 'Anula documento de referencia' },
    { code: '02', name: 'Corrige texto del documento' },
    { code: '04', name: 'Referencia a otro documento' },
    { code: '05', name: 'Sustituye comprobante de contingencia' },
    { code: '06', name: 'Devolución de mercadería' },
    { code: '07', name: 'Sustituye comprobante electrónico' },
    { code: '08', name: 'Factura endosada' },
    { code: '09', name: 'Nota de crédito financiera' },
    { code: '10', name: 'Nota de débito financiera' },
    { code: '11', name: 'Proveedor no domiciliado' },
    { code: '12', name: 'Crédito por exoneración posterior' },
    { code: '99', name: 'Otros' },
]);
/** TipoDocumentoEX1 (Exoneración). */
export const EXONERATION_TYPES = entries([
    { code: '01', name: 'Compras autorizadas por la DGT' },
    { code: '02', name: 'Ventas exentas a diplomáticos' },
    { code: '03', name: 'Autorizado por ley especial' },
    { code: '04', name: 'Exenciones DGH · autorización local genérica' },
    { code: '05', name: 'Exenciones DGH · Transitorio V' },
    { code: '06', name: 'Servicios turísticos inscritos ante el ICT' },
    { code: '07', name: 'Transitorio XVII · reciclaje' },
    { code: '08', name: 'Exoneración a zona franca' },
    { code: '09', name: 'Servicios complementarios a la exportación' },
    { code: '10', name: 'Órgano de corporaciones municipales' },
    { code: '11', name: 'Exenciones DGH · autorización local concreta' },
    { code: '99', name: 'Otros' },
]);
/** Tipos que exigen Artículo en la exoneración. */
export const EXONERATION_REQUIRES_ARTICLE = ['02', '03', '06', '07', '08'];
/** NombreInstitucion (Exoneración). */
export const EXONERATION_INSTITUTIONS = entries([
    { code: '01', name: 'Ministerio de Hacienda' },
    { code: '02', name: 'Ministerio de Relaciones Exteriores y Culto' },
    { code: '03', name: 'Ministerio de Agricultura y Ganadería' },
    { code: '04', name: 'Ministerio de Economía, Industria y Comercio' },
    { code: '05', name: 'Cruz Roja Costarricense' },
    { code: '06', name: 'Benemérito Cuerpo de Bomberos' },
    { code: '07', name: 'Asociación Obras del Espíritu Santo' },
    { code: '08', name: 'FECRUNAPA' },
    { code: '09', name: 'Universidad EARTH' },
    { code: '10', name: 'INCAE' },
    { code: '11', name: 'Junta de Protección Social' },
    { code: '12', name: 'ARESEP' },
    { code: '99', name: 'Otros' },
]);
/** TipoDocumentoOC (OtrosCargos). */
export const OTHER_CHARGE_TYPES = entries([
    { code: '01', name: 'Contribución parafiscal' },
    { code: '02', name: 'Timbre de la Cruz Roja' },
    { code: '03', name: 'Timbre del Cuerpo de Bomberos' },
    { code: '04', name: 'Cobro de un tercero' },
    { code: '05', name: 'Costos de exportación' },
    { code: '06', name: 'Impuesto de servicio 10%' },
    { code: '07', name: 'Timbre de colegios profesionales' },
    { code: '08', name: 'Depósito de garantía' },
    { code: '09', name: 'Multas o penalizaciones' },
    { code: '10', name: 'Intereses moratorios' },
    { code: '99', name: 'Otros cargos' },
]);
/** CondicionImpuesto (mensaje receptor). */
export const TAX_CONDITIONS = entries([
    { code: '01', name: 'Genera crédito de IVA' },
    { code: '02', name: 'Genera crédito parcial de IVA' },
    { code: '03', name: 'Bienes de capital' },
    { code: '04', name: 'Gasto corriente, no genera crédito' },
    { code: '05', name: 'Proporcionalidad' },
]);
/** Mensaje del receptor ante un comprobante recibido. */
export const RECEPTION_DECISIONS = entries([
    { code: '1', name: 'Aceptado' },
    { code: '2', name: 'Aceptado parcialmente' },
    { code: '3', name: 'Rechazado' },
]);
/** Unidades de medida (Anexo "Unidades de medida"). Las primeras son las de uso diario. */
export const UNITS = [
    { code: 'Unid', name: 'Unidad' },
    { code: 'Sp', name: 'Servicios profesionales' },
    { code: 'Os', name: 'Otro servicio' },
    { code: 'St', name: 'Servicio' },
    { code: 'Spe', name: 'Servicios profesionales (especiales)' },
    { code: 'h', name: 'Hora' },
    { code: 'Kg', name: 'Kilogramo' },
    { code: 'm', name: 'Metro' },
    { code: 's', name: 'Segundo' },
    { code: 'A', name: 'Amperio' },
    { code: 'K', name: 'Kelvin' },
    { code: 'mol', name: 'Mol' },
    { code: 'cd', name: 'Candela' },
    { code: 'G', name: 'Gramo' },
    { code: 'L', name: 'Litro' },
    { code: 'mL', name: 'Mililitro' },
    { code: 'm²', name: 'Metro cuadrado' },
    { code: 'm³', name: 'Metro cúbico' },
    { code: 'Km', name: 'Kilómetro' },
    { code: 'cm', name: 'Centímetro' },
    { code: 'Mm', name: 'Milímetro' },
    { code: 'D', name: 'Docena' },
    { code: 'Cm', name: 'Comisión' },
    { code: 'Gal', name: 'Galón' },
    { code: 'Oz', name: 'Onza' },
    { code: 'Min', name: 'Minuto' },
    { code: 'I', name: 'Itinerario' },
    { code: 'Fa', name: 'Fardo' },
    { code: 'Cu', name: 'Cubo' },
    { code: 'M', name: 'Millar' },
    { code: 'Qq', name: 'Quintal' },
    { code: 't', name: 'Tonelada' },
    { code: 'kWh', name: 'Kilowatt hora' },
    { code: 'Acv', name: 'Año vehículo' },
    { code: 'Al', name: 'Alcohol' },
    { code: 'Alc', name: 'Alcohol (grado)' },
    { code: 'Cc', name: 'Centímetro cúbico' },
    { code: 'U', name: 'Unidad (U)' },
    // Resto de la tabla de unidades del sistema anterior (símbolos SI y derivadas).
    { code: 'm/s', name: 'Metro por segundo' },
    { code: 'm/s²', name: 'Metro por segundo cuadrado' },
    { code: '1/m', name: '1 por metro' },
    { code: 'kg/m³', name: 'Kilogramo por metro cúbico' },
    { code: 'A/m²', name: 'Amperio por metro cuadrado' },
    { code: 'A/m', name: 'Amperio por metro' },
    { code: 'mol/m³', name: 'Mol por metro cúbico' },
    { code: 'cd/m²', name: 'Candela por metro cuadrado' },
    { code: '1', name: 'Uno (índice de refracción)' },
    { code: 'rad', name: 'Radián' },
    { code: 'sr', name: 'Estereorradián' },
    { code: 'Hz', name: 'Hertz' },
    { code: 'N', name: 'Newton' },
    { code: 'Pa', name: 'Pascal' },
    { code: 'J', name: 'Joule' },
    { code: 'W', name: 'Watt' },
    { code: 'C', name: 'Coulomb' },
    { code: 'V', name: 'Volt' },
    { code: 'F', name: 'Farad' },
    { code: 'Ω', name: 'Ohm' },
    { code: 'S', name: 'Siemens' },
    { code: 'Wb', name: 'Weber' },
    { code: 'T', name: 'Tesla' },
    { code: 'H', name: 'Henry' },
    { code: '°C', name: 'Grado Celsius' },
    { code: 'Bq', name: 'Becquerel' },
    { code: 'Otros', name: 'Otros' },
];
/**
 * Busca una unidad por su símbolo: primero exacto (s segundo / S siemens, m metro / M millar) y, si no hay,
 * sin distinguir mayúsculas (kg -> Kg). `null` si no existe en el catálogo.
 */
export function resolveUnit(raw) {
    const wanted = raw?.trim();
    if (!wanted)
        return null;
    return (UNITS.find((u) => u.code === wanted)?.code ??
        UNITS.find((u) => u.code.toLowerCase() === wanted.toLowerCase())?.code ??
        null);
}
/** Unidades que Hacienda trata como servicio al no haber CABYS. */
export const SERVICE_UNITS = ['Sp', 'Os', 'St', 'Spe', 'h', 'Min', 'Cm', 'I', 'Al', 'Alc'];
/** Un CABYS que empieza con 5–9 es un servicio. */
export function isServiceLine(cabys, unit) {
    if (cabys && /^\d{13}$/.test(cabys))
        return Number(cabys[0]) >= 5;
    return SERVICE_UNITS.includes(unit);
}
/** Estado del comprobante frente a Hacienda. */
export const HACIENDA_STATUSES = entries([
    { code: 'draft', name: 'Borrador' },
    { code: 'pending', name: 'Por enviar' },
    { code: 'sent', name: 'Enviado' },
    { code: 'processing', name: 'Procesando' },
    { code: 'accepted', name: 'Aceptado' },
    { code: 'rejected', name: 'Rechazado' },
    { code: 'error', name: 'Error' },
    { code: 'internal', name: 'Interno' },
]);
//# sourceMappingURL=hacienda.js.map